import { Box, styled, Typography } from '@mui/material';
import { ReactComponent as CoinDark } from '@/assets/images/coin-dark.svg';

const Main = styled(Box)(({ theme }) => ({
  paddingBlock: 8,
  borderBottomWidth: 1,
  gap: 12,
  borderBottomStyle: 'solid',
  display: 'flex',
  alignItems: 'center',
  borderBottomColor: theme.palette.border.main,
  transform: 'scale(1)',
  animationName: 'fadeInScale',
  animationDuration: '200ms',
  animationFillMode: 'forwards',
  animationTimingFunction: 'ease-out',
  transition: 'border-color 0.2s ease, outline-color 0.2s ease',
}));

const Points = styled(Box)(({ theme }) => ({
  borderWidth: 1,
  minWidth: 44,
  width: 44,
  height: 44,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  borderStyle: 'solid',
  borderColor: theme.palette.border.main,
}));

const ButtonWrapper = styled('button')(() => ({
  all: 'unset',
  cursor: 'pointer',
  marginLeft: 'auto',
  padding: 4,
  borderRadius: 10,
  backgroundClip: 'padding-box',
  background: 'linear-gradient(to left, #CCF526, #ABD600)',
  boxShadow: '0px 12px 40px rgba(204, 245, 38, 0.5)',
}));

const Button = styled(Box)(() => ({
  height: 32,
  paddingInline: 16,
  borderRadius: 8,
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '16px',
  backgroundColor: 'black',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
}));

type Props = {
  points: number;
  index: number;
  name: string;
  onClick: () => void;
};

export default function RewardRow({ points, index, name, onClick }: Props) {
  return (
    <Main style={{ animationDelay: `${index * 50}ms` }}>
      <Points>
        <Typography fontSize={14} fontWeight={600} lineHeight="16px" color="black">
          {points}
        </Typography>
        <CoinDark width={14} height={14} />
      </Points>
      <Typography fontSize={14} fontWeight={700} lineHeight="100%" color="black">
        {name}
      </Typography>
      <ButtonWrapper onClick={onClick}>
        <Button>Collect</Button>
      </ButtonWrapper>
    </Main>
  );
}
